// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__x97KF","consentsList":"PatientConsents_consentsList__3JCDg","consentsListEmpty":"PatientConsents_consentsListEmpty__1Bq2_"};